let categoriesSwiper = document.querySelector("[swiper='categories']");

if (categoriesSwiper) {
  const swiperElement = categoriesSwiper.querySelector(".swiper");

  const prevButton = categoriesSwiper.querySelector("[swiper='prev']");
  const nextButton = categoriesSwiper.querySelector("[swiper='next']");

  var swiper = new Swiper(swiperElement, {
    speed: 300,
    slidesPerView: "auto",
    spaceBetween: 12,
    loop: false,
    centeredSlides: false,
    mousewheel: { forceToAxis: true },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
      disabledClass: "hide",
    },
    breakpoints: {
      0: { slidesPerView: 2, spaceBetween: 10, slidesPerGroup: 1 },
      480: { slidesPerView: 2, spaceBetween: 20, slidesPerGroup: 1 },
      768: { slidesPerView: 2, spaceBetween: 20, slidesPerGroup: 1 },
      992: { slidesPerView: 4, spaceBetween: 12, slidesPerGroup: 1 },
      1200: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      1600: {
        slidesPerView: 6
      },
    },
  });
}
